export default {
  filter: {
    searchPammName: 'Search PAMM Name',
    joinWay: 'Join Method',
    startTime: 'Start Time',
    endTime: 'End Time',
    search: 'Search',
    reset: 'Reset',
    joinWayOptions: {
      purchase: 'Purchase',
      redeem: 'Redeem',
    },
  },
  table: {
    columns: {
      pammName: 'PAMM Name',
      joinAccount: 'Join Account',
      joinWay: 'Join Method',
      payWay: 'Payment Method',
      changeAmount: 'Change Amount',
      accountBalance: 'Account Balance',
      createTime: 'Created Time',
    },
  },
}